import { post } from "../common/helpers/http";

interface Cookie {
  domain: string;
  expirationDate?: number;
  hostOnly: boolean;
  httpOnly: boolean;
  name: string;
  path: string;
  sameSite: string;
  secure: boolean;
  session: boolean;
  storeId: string;
  value: string;
}

const LoginExtension = () => {
  function connectLinkedInAccount(accountId: string) {
    return post("account", {
      account_id: accountId,
    });
  }

  function getAccountFromCookies(cookies: Cookie[], countryCode: string) {
    const formattedCookiesPayload = {
      cookies,
      proxy_config: {
        "location.countryISO": {
          $eq: countryCode,
        },
        "provider.name": {
          $eq: "nord",
        },
      },
    };
    return post(`account/from-cookies`, formattedCookiesPayload);
  }

  return {
    connectLinkedInAccount,
    getAccountFromCookies,
  };
};

export default LoginExtension;
